<template>
    <div>
        <div class="d-flex">
            <div class="input-block w-100 mr-1">
                <label for="first-name">First Name</label>
                <input
                    id="first-name"
                    maxlength="50"
                    name="leadHousemate[first_name]"
                    required
                    placeholder="e.g. John"
                    type="text"
                    v-model="fields.first_name"
                />
            </div>
            <div class="input-block w-100 ml-1">
                <label for="last-name">Last Name</label>
                <input
                    id="last-name"
                    maxlength="50"
                    required
                    name="leadHousemate[last_name]"
                    placeholder="e.g. Smith"
                    type="text"
                    v-model="fields.last_name"
                />
            </div>
        </div>

        <div class="input-block">
            <input
                type="tel"
                name="leadHousemate[phone_number]"
                :value="fields.phone_number.formatted"
                hidden
            />

            <label for="national-number">Mobile Number</label>
            <telephone-input
                class="flex-nowrap"
                placeholder="e.g. 7700 900123"
                v-model="fields.phone_number"
                name="leadHousemate[telephone_number]"
            ></telephone-input>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
import TelephoneInput from "../../telephoneinput/TelephoneInput";

export default {
    name: "InviteMainBillPayer",

    components: {
        TelephoneInput,
    },

    data() {
        return {
            fields: {
                first_name: "",
                last_name: "",
                phone_number: {
                    formatted: "",
                    country_code: "",
                    national_number: "",
                },
            },
        };
    },
    watch: {
        fields: {
            handler() {
                store.commit(
                    "invite/updateCurrentBillPayer",
                    _.cloneDeep(this.$data.fields)
                );
            },
            deep: true,
        },
    },
};
</script>
